import { useEffect, useState } from 'react';

// Starts at 00:17:34, counts down to 00:00:00 and restarts automatically.
const DURATION = 17 * 60 + 34;
const START = Date.now();

function remaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION - (elapsed % (DURATION + 1));
}

export function useCountdown() {
  const [seconds, setSeconds] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setSeconds(remaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    secs: seconds % 60,
  };
}
